import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';

export type TopPageUrlResponse = {
  url: string;
};

export const companySiteApiClient = {
  topPageUrl: async (): Promise<ApiResult<TopPageUrlResponse>> => {
    return await axiosClient.get('/company/top-page-url');
  },
};
